import { Button } from '@iveco-ti/iveco-ds'
import { CheckCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { ROUTES } from '@/common/constants/routes'

type SuccessMessageProps = {
  newPasswordToken: string
}

export function SuccessMessage({ newPasswordToken }: SuccessMessageProps) {
  const { t } = useTranslation('login')

  return (
    <div className="flex flex-col gap-6">
      <div className="bg-brand-50 border border-brand-200 rounded-lg p-6 text-center">
        <CheckCircle className="text-brand-600 size-12 mx-auto mb-4" />
        <h3 className="text-brand-900 font-medium mb-2">
          {t('activate_user.success.title')}
        </h3>
        <p className="text-brand-700 text-sm">
          {t('activate_user.success.message')}
        </p>
      </div>

      <Link
        to={`${ROUTES.LOGIN.NEW_PASSWORD}?verify-token=${newPasswordToken}`}
      >
        <Button.Root size="lg" block>
          {t('activate_user.set_password_button')}
        </Button.Root>
      </Link>
    </div>
  )
}
